import ProductionLayout from '@/screens/production'
import Production from '@/screens/production/Production'

import auth from './middleware/auth'

const routes = [
  {
    path: '/:area/production',
    name: 'ProductionLayout',
    component: ProductionLayout,
    meta: { requireAuth: true },
    children: [
      {
        path: 'subrecipes',
        name: 'Production',
        component: Production,
        meta: {
          requireAuth: true,
          permissions: ['manager', 'buyer', 'chef'],
          middleware: { auth }
        }
      }
    ]
  }
]

export default routes
